const ActionType = {
    SIDER_COLLAPSED: 'siderCollapsed'
};

export default ActionType